export const siteConfig = {
  name: "长日光阴",
  englishName: "SUNDAY CINEMA",
  slogan: "把每一段光影，都留在好日子里",
  contactEmail: "hello@changri-guangyin.demo",
  address: "北京市朝阳区光影路 88 号 长日光阴编辑部",
  description:
    "长日光阴网站致力于提供最新电影、电视剧资讯和影视资源，覆盖各类热门影视作品，满足用户多样化的观影需求。",
};

export const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];